import { z as s } from "zod/v4-mini";
const t = {
  CashGames: "cash-games",
  PokerTable: "poker-table",
  PowerPath: "power-path",
  Rewards: "rewards"
}, o = {
  [t.CashGames]: ["holdem", "omaha", "all-in"],
  [t.PokerTable]: ["default"],
  [t.PowerPath]: ["more", "overview", "the-passes", "the-path"],
  [t.Rewards]: ["tournament-tickets"]
}, g = {
  [t.CashGames]: "holdem",
  [t.PokerTable]: "default",
  [t.PowerPath]: "the-path",
  [t.Rewards]: "tournament-tickets"
}, h = s.object({
  token: s.string()
}), c = s.object({
  installId: s.string()
}), d = s.enum([
  "login",
  "logout",
  "spadeReady",
  "tokenUpdated",
  "unregisterSpade",
  "navigation",
  "installId",
  "spade.cashGames.open",
  "spade.tournament.register"
]);
s.discriminatedUnion("view", [
  s.object({
    view: s.literal(t.CashGames),
    path: s.enum(o[t.CashGames])
  }),
  s.object({
    view: s.literal(t.PokerTable),
    path: s.enum(o[t.PokerTable])
  }),
  s.object({
    view: s.literal(t.PowerPath),
    path: s.enum(o[t.PowerPath])
  }),
  s.object({
    view: s.literal(t.Rewards),
    path: s.enum(o[t.Rewards])
  })
]);
class p {
  iframeReady = !1;
  pendingToken;
  pendingInstallId;
  iframes = /* @__PURE__ */ new Map();
  isIframe = window !== window.parent;
  messageHandler = this.handleMessage.bind(this);
  callbacks = /* @__PURE__ */ new Map();
  constructor() {
    window.addEventListener("message", this.messageHandler, !1), this.on("spadeReady", () => {
      this.iframeReady = !0, this.pendingToken && (this.broadcast("tokenUpdated", { token: this.pendingToken }), this.pendingToken = void 0), this.pendingInstallId && (this.broadcast("installId", { installId: this.pendingInstallId }), this.pendingInstallId = void 0);
    }), this.on("unregisterSpade", () => {
      this.iframeReady = !1, this.pendingToken = void 0;
    });
  }
  registerIframe(e, a, i) {
    this.iframes.set(e, { iframe: a, origin: i });
  }
  unregisterIframe(e) {
    const a = this.iframes.get(e);
    a && a.iframe.remove(), this.iframes.delete(e), this.broadcast("unregisterSpade");
  }
  destroy() {
    window.removeEventListener("message", this.messageHandler), this.callbacks.clear(), this.iframes.forEach((e) => {
      e.iframe.parentNode && e.iframe.parentNode.removeChild(e.iframe);
    }), this.iframes.clear();
  }
  setToken(e) {
    const a = h.parse(e);
    this.pendingToken = a.token, this.iframeReady && (this.broadcast("tokenUpdated", { token: a.token }), this.pendingToken = void 0);
  }
  setInstallId(e) {
    const a = c.parse(e);
    this.pendingInstallId = a.installId, this.iframeReady && (this.broadcast("installId", { installId: a.installId }), this.pendingInstallId = void 0);
  }
  login() {
    this.broadcast("login");
  }
  logout() {
    this.broadcast("logout");
  }
  on(e, a) {
    const i = d.parse(e);
    return this.callbacks.has(i) || this.callbacks.set(i, /* @__PURE__ */ new Set()), this.callbacks.get(i)?.add(a), { off: () => this.off(i, a) };
  }
  off(e, a) {
    this.callbacks.get(e)?.delete(a), this.callbacks.get(e)?.size === 0 && this.callbacks.delete(e);
  }
  emit(e, a) {
    this.callbacks.get(e)?.forEach((i) => i(a));
  }
  handleMessage(e) {
    const { type: a, payload: i } = e.data, n = d.safeParse(a);
    if (n.success) {
      if (!this.isIframe && !new Set(
        Array.from(this.iframes.values()).map((l) => l.origin)
      ).has(e.origin)) {
        console.error(`Unauthorized message origin: ${e.origin}`);
        return;
      }
      this.emit(n.data, i);
    }
  }
  broadcast(e, a) {
    const i = { type: e, payload: a };
    this.isIframe ? window.parent.postMessage(i, window.document.referrer) : this.iframes.forEach(({ iframe: n, origin: r }) => {
      n.contentWindow?.postMessage(i, r);
    }), this.emit(e, a);
  }
}
export {
  d as ActionSchema,
  p as EmbeddedAPI,
  c as InstallIdSchema,
  h as TokenSchema,
  g as defaultPathByView,
  o as pathsByView,
  t as spadeView
};
//# sourceMappingURL=index.mjs.map
